import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';
import { AlertSingleLine, Loader, SdirButton, SdirInput, styles } from '@sdir/sds';
import { useApi } from '@sdir/httpclient/lib/hooks/useApi';
import { AcceptReporteeInviteRequest } from '@sdir/httpclient/lib/clients/aps/endorsement';
import { ErrorMessage } from '@sdir/utilities/lib/components';
import { endorsementApi } from '../../httpclient';

const CodePage: React.FC = () => {
  const intl = useIntl();
  const [code, setCode] = useState<string>();
  const [showSuccess, setShowSuccess] = useState<boolean>(false);

  const {
    errorObject: submitError,
    loading: submitLoading,
    callApi: submit,
  } = useApi({
    apiFunction: (payload) => endorsementApi.acceptReporteeInvite(payload),
    successCallback: () => {
      setCode('');
      setShowSuccess(true);
    },
  });

  const onCodeChange = (e: any) => {
    const value = e?.target?.value || '';
    setCode(value);
  };

  const submitCode = () => {
    const payload: AcceptReporteeInviteRequest = {
      code,
    };
    submit(payload);
  };

  return (
    <Wrapper>
      <H1>{intl.formatMessage({ id: 'code.title' })}</H1>
      <p>{intl.formatMessage({ id: 'code.ingress' })}</p>
      <div>
        <SdirInput type="text" onChange={onCodeChange} placeholder="Enter code" maxLength={5} />
        <SdirButton
          onClick={submitCode}
          type="primary"
          disabled={code?.length !== 5}
          text="Submit"
        />
      </div>
      {submitLoading && (
        <FeedbackWrapper>
          <Loader />
        </FeedbackWrapper>
      )}
      {showSuccess && (
        <FeedbackWrapper>
          <AlertSingleLine
            type="success"
            title="Success"
            text="You accepted the invitation successfully!"
          />
        </FeedbackWrapper>
      )}
      {submitError && (
        <FeedbackWrapper>
          <ErrorMessage error={submitError} />
        </FeedbackWrapper>
      )}
    </Wrapper>
  );
};

export default CodePage;

const Wrapper = styled.div`
  & > div {
    display: flex;
    input {
      max-width: 200px;
    }
    button {
      margin-left: 20px;
    }
  }
`;

const H1 = styled.h1`
  font-size: 4rem;
  font-family: ${styles.fonts.stfMedium};
  font-weight: normal;
`;

const FeedbackWrapper = styled.div`
  margin-top: 20px;
`;
